export const HIGH_RATING = 'review>3';

// MUEBLES CATEGORY
export const DEFAULT_GIFT_CATEGORY = 4497;
